export class VehtelBeaconType {
    public flag: number;
    public name: string;
}
